export default {
    computed:{
        dateFormat(){
            return "DD.MM.YYYY";
        }
    },
    methods: {
        timeTitle(eventParsed) {

            let startTime = `${eventParsed.start.hour}:${(eventParsed.start.minute < 10 ? '0' + eventParsed.start.minute : eventParsed.start.minute)}`;
            let endTime = `${eventParsed.end.hour}:${(eventParsed.end.minute < 10 ? '0' + eventParsed.end.minute : eventParsed.end.minute)}`;
            let startDateFormatted = this.$moment(eventParsed.start.date).format(this.dateFormat);
            let endDateFormatted = this.$moment(eventParsed.end.date).format(this.dateFormat);
            return `${startDateFormatted} ${startTime} - ${(eventParsed.end.date == eventParsed.start.date) ? '' : endDateFormatted + ' '}${endTime}`
        },
        timeForShow(eventParsed){
            return `${eventParsed.start.hour}:${(eventParsed.start.minute <10 ? '0'+eventParsed.start.minute : eventParsed.start.minute)}`
        },
        compareRepairtimesDateForSort(a, b){
            if(!(a.interval && b.interval)) return 0;
            let ch1 = (typeof a.interval.start ==='string') ? a = Date.parse(a.interval.start) : a.interval.start;
            let ch2 = (typeof b.interval.start ==='string') ? a = Date.parse(b.interval.start) : b.interval.start;

            if(ch1 < ch2) return -1;
            if(ch1 > ch2) return 1;
            return 0;
        },
    }
}